import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { activitiesData } from '../../data/ActivitiesData'; // Adjust the path as needed
import styles from './ActivityDetails.module.scss';

const ActivityDetails: React.FC = () => {
  const { id } = useParams<{ id: string }>(); // Get the activity ID from the URL
  const { t } = useTranslation();

  // Try to get translated activity data
  const translatedActivity = t(`activitiesData.${id}`, { returnObjects: true }) as {
    heading?: string;
    description?: string;
  };

  // Fallback to static activitiesData if translation is not available or incomplete
  const activityFromData = activitiesData.find((act) => act.id === Number(id));
  const activity = {
    id: Number(id),
    heading: translatedActivity.heading || activityFromData?.heading || 'Activity Not Found',
    description: translatedActivity.description || activityFromData?.description || '',
    image: activityFromData?.image || '',
    date: activityFromData?.date || '',
  };

  if (!activityFromData) {
    return <div className={styles.error}>Activity not found</div>;
  }

  return (
    <div className={styles.activityDetailsContainer}>
      <h1 className={styles.heading}>{activity.heading}</h1>
      <img src={activity.image} alt={activity.heading} className={styles.image} />
      <p className={styles.date}>
        {new Date(activity.date).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        })}
      </p>
      <p className={styles.description}>{activity.description}</p>
      <Link to='/blogs' className={styles.backLink}>
        {t('navigation.backToActivities', { defaultValue: 'Back to Activities' })}
      </Link>
    </div>
  );
};

export default ActivityDetails;
